import InputSkeleton, { InputSkeletonProps } from './input-skeleton';

export type { InputSkeletonProps };

export default InputSkeleton;
